import { ValueOf } from './shared.interface';

export enum SORT_DIRECTION {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SORT_BY_TYPE = SORT_BY_PRODUCTS | SORT_BY_SALES;

export const CURRENCY: Record<string, string> = {
  EURO: '€',
  UK_POUNDS: '£',
  USA_DOLLAR: '$',
  EUR: '€',
  GBP: '£',
  USD: '$',
};

export enum SORT_BY_PRODUCTS {
  NAME = 'name',
  INTERNAL_ID = 'internalId',
  INTERNAL_SERIAL = 'internalSerial',
  CREATED_AT = 'createdAt',
}

export enum SORT_BY_CUSTOMERS {
  COMPANY_NAME = 'companyName',
  VAT_NUMBER = 'vatNumber',
  CREATED_AT = 'createdAt',
  CUSTOMER_SUBTOTAL = 'customerSubtotal',
  SUPPLIER_SUBTOTAL = 'supplierSubtotal',
}

export enum SORT_BY_SALES {
  SERIES_NAME = 'seriesName',
  SERIAL_NUMBER = 'serialNumber',
  YEAR = 'year',
  SENT_TO_AADE_AT = 'sentToAadeAt',
  CREATED_AT = 'createdAt',
  CUSTOMER = 'customerId',
  PAYMENT_TYPE = 'paymentTypeId',
  DOCUMENT_TYPE = 'documentTypeId',
  TOTAL_VALUE = 'totalValue',
}

export enum SORT_BY_MONEY_COLLECTION {
  CREATED_AT = 'createdAt',
}

export enum SUBSCRIPTION {
  'PROVIDER_CREDITS_500' = '0',
  'PROVIDER_CREDITS_3000' = '00',
  'PROVIDER_CREDITS_10000' = '000',
  'PROVIDER_CREDITS_50000' = '0000',
  'PROVIDER_CREDITS_100000' = '00000',
  'PROVIDER_CREDITS_300000' = '000000',
  'PROVIDER_CREDITS_500000' = '0000000',
  'SIMPLE_V1' = '1',
  'SUBTOTALS' = '3',
}

export const CURRENT_BIGGEST_SUBSCRIPTION_ID = 3;

export const BILL_EASE_VAT_NUMBER = '802337269';

export const STANDALONE_FEATURE = {
  TRANSIT: '100',
} as const;

export type StandaloneFeatureType = ValueOf<typeof STANDALONE_FEATURE>;

export const STANDALONE_FEATURES_IDS = Object.values(STANDALONE_FEATURE);

export const STANDALONE_FEATURE_LABEL: Record<string, string> = {
  [STANDALONE_FEATURE.TRANSIT]: 'SETTINGS.FEATURE_TRANSIT',
};
